/**
 * Animates a small "flying" image/chip from the clicked element to the header bag icon.
 * Falls back silently when the bag icon isn't on screen or motion is reduced.
 */
export const flyToBag = (source: Element | null, imageUrl?: string | null) => {
  if (typeof window === "undefined" || !source) return;
  if (window.matchMedia?.("(prefers-reduced-motion: reduce)").matches) return;

  const target = document.querySelector("[data-bag-icon]");
  if (!target) return;

  const from = source.getBoundingClientRect();
  const to = target.getBoundingClientRect();
  if (!from.width || !to.width) return;

  const size = 72;
  const flyer = document.createElement("div");
  flyer.style.cssText = [
    "position:fixed",
    "z-index:9999",
    "pointer-events:none",
    `width:${size}px`,
    `height:${size}px`,
    "overflow:hidden",
    "box-shadow:0 10px 30px rgba(0,0,0,0.35)",
    "background:#1a1a1a",
    `left:${from.left + from.width / 2 - size / 2}px`,
    `top:${from.top + from.height / 2 - size / 2}px`,
  ].join(";");

  if (imageUrl) {
    const img = document.createElement("img");
    img.src = imageUrl;
    img.alt = "";
    img.style.cssText = "width:100%;height:100%;object-fit:cover;display:block";
    flyer.appendChild(img);
  }

  document.body.appendChild(flyer);

  const dx = to.left + to.width / 2 - (from.left + from.width / 2);
  const dy = to.top + to.height / 2 - (from.top + from.height / 2);

  const animation = flyer.animate(
    [
      { transform: "translate(0px, 0px) scale(1)", opacity: 1 },
      { transform: `translate(${dx * 0.5}px, ${dy * 0.5 - 80}px) scale(0.6)`, opacity: 0.95, offset: 0.6 },
      { transform: `translate(${dx}px, ${dy}px) scale(0.1)`, opacity: 0.2 },
    ],
    { duration: 750, easing: "cubic-bezier(0.4, 0, 0.2, 1)" },
  );

  animation.onfinish = () => {
    flyer.remove();
    window.dispatchEvent(new CustomEvent("bag:bump"));
  };
  animation.oncancel = () => flyer.remove();
};
